import is from '@sindresorhus/is';
import { createContext, useContext } from 'react';

import type { CommentsFetchers } from '../fetchers/job-architecture/job-architecture-comments-fetchers';
import type { CommentKeys } from './api/cache/comment-keys';

export type CommentsApi = {
    readonly fetchers: CommentsFetchers;
    readonly keys: CommentKeys;
};

export const CommentsApiContext = createContext<CommentsApi | null>(null);

export const useCommentsApi = (): CommentsApi => {
    const value = useContext(CommentsApiContext);
    if (is.null(value)) {
        throw new Error('useCommentsApi must be used inside a comments scope provider');
    }
    return value;
};

export const useOptionalCommentsApi = (): CommentsApi | null => {
    return useContext(CommentsApiContext);
};
